<!-- 
/**
 * Product search results' item column component.
 * 
 * @since 2.0.0
 * @author Fahri Rusliyadi <fahri.rusliyadi@gmail.com>
 */
-->

<template>
    <td v-html="item[$vnode.key]"></td>
</template>

<script>
    export default {
        /**
         * Custom attributes. 
         * 
         * @since 2.0.0
         * @type {String[]}
         */
        props: [
            /**
             * Product data.
             * 
             * @since 2.0.0
             * @type {Object}
             */
            'item'
        ]
    }
</script>